import React, { useEffect, useState } from "react";
import { Col, Modal, ModalBody, Row, Spinner } from "reactstrap";
import { IoCloseSharp } from "react-icons/io5";
import toast from "react-hot-toast";
import FormInput from "../formInput/FormInput";
import GeneralButton from "../button/GeneralButton";
import { saveData, uniqueID } from "../../firebase/utility";

const AddNewUsAddressModal = ({ modal, toggle, refreshData, isUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    company: "",
    first_name: "",
    last_name: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    postcode: "",
    country: "USA",
    email: "",
    phone: "",
    quickbooks_id: "",
  });

  useEffect(() => {
    if (isUpdate && modal) {
      setData({ ...isUpdate });
    } else if (modal && !isUpdate) {
      setData({
        company: "",
        first_name: "",
        last_name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        postcode: "",
        country: "USA",
        email: "",
        phone: "",
        quickbooks_id: "",
      });
    }
  }, [isUpdate, modal]);

  const handleSubmit = async () => {
    if (!data.company || !data.first_name || !data.address_1 || !data.city || !data.state) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);
    try {
      const id = isUpdate?._id || isUpdate?.id || uniqueID();
      const payload = { ...data, _id: id };
      await saveData("USAddresses", id, payload);
      toast.success(`Address ${isUpdate ? "updated" : "added"} successfully`);
      refreshData();
      toggle();
    } catch (error) {
      toast.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-0">
        <div className="d-flex justify-content-between align-items-center p-4 border-bottom bg-light">
          <h4 className="fw-bold mb-0">
            {isUpdate ? "Update US Address" : "Add New US Address"}
          </h4>
          <IoCloseSharp size={24} className="text-muted pointer" onClick={toggle} />
        </div>
        
        <div className="p-4">
          <Row className="g-3">
            <Col md={12}>
              <FormInput
                label="Company Name *"
                value={data.company}
                handleChange={(e) => setData({ ...data, company: e.target.value })}
                placeholder="e.g. TechMicro USA INC"
              />
            </Col>
            <Col md={6}>
              <FormInput
                label="First Name *"
                value={data.first_name}
                handleChange={(e) => setData({ ...data, first_name: e.target.value })}
                placeholder="e.g. Receiving"
              />
            </Col>
            <Col md={6}>
              <FormInput
                label="Last Name"
                value={data.last_name}
                handleChange={(e) => setData({ ...data, last_name: e.target.value })}
                placeholder="e.g. Department"
              />
            </Col>
            <Col md={12}>
              <FormInput
                label="Address Line 1 *"
                value={data.address_1}
                handleChange={(e) => setData({ ...data, address_1: e.target.value })}
                placeholder="Street address, P.O. box, etc."
              />
            </Col>
            <Col md={12}>
              <FormInput
                label="Address Line 2"
                value={data.address_2}
                handleChange={(e) => setData({ ...data, address_2: e.target.value })}
                placeholder="Apartment, suite, unit, building, floor, etc."
              />
            </Col>
            <Col md={6}>
              <FormInput
                label="City *"
                value={data.city}
                handleChange={(e) => setData({ ...data, city: e.target.value })}
                placeholder="City"
              />
            </Col>
            <Col md={3}>
              <FormInput
                label="State *"
                value={data.state}
                handleChange={(e) => setData({ ...data, state: e.target.value })}
                placeholder="State (e.g. IL)"
              />
            </Col>
            <Col md={3}>
              <FormInput
                label="ZIP / Postcode *"
                value={data.postcode}
                handleChange={(e) => setData({ ...data, postcode: e.target.value })}
                placeholder="ZIP code"
              />
            </Col>
            <Col md={4}>
              <FormInput
                label="Email"
                type="email"
                value={data.email}
                handleChange={(e) => setData({ ...data, email: e.target.value })}
                placeholder="Email address"
              />
            </Col>
            <Col md={4}>
              <FormInput
                label="Phone"
                value={data.phone}
                handleChange={(e) => setData({ ...data, phone: e.target.value })}
                placeholder="Phone number"
              />
            </Col>
            <Col md={4}>
              <FormInput
                label="QuickBooks ID"
                value={data.quickbooks_id}
                handleChange={(e) => setData({ ...data, quickbooks_id: e.target.value })}
                placeholder="Optional"
              />
            </Col>
          </Row>
          
          <div className="d-flex justify-content-end gap-3 mt-4">
            <GeneralButton
              title="Cancel"
              className="bg-white text-dark border px-4"
              handleClick={toggle}
              disabled={loading}
            />
            <GeneralButton
              title={loading ? <Spinner size="sm" /> : isUpdate ? "Update" : "Save"}
              className="bg-primary text-white px-4"
              handleClick={handleSubmit}
              disabled={loading}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddNewUsAddressModal;
